import React from 'react';

import PropTypes from 'prop-types';

function HangarIcon({ width = 68, height = 48, color = '#C7C9C3', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 68 48"
      fill="none"
      {...rest}
    >
      <path
        d="M65.6831 39.15L37.4906 18L44.0888 13.05C44.3687 12.8407 44.5961 12.5691 44.7528 12.2566C44.9095 11.9442 44.9912 11.5995 44.9916 11.25C44.9916 8.26631 43.8063 5.40483 41.6965 3.29505C39.5867 1.18526 36.7253 0 33.7416 0C30.7579 0 27.8964 1.18526 25.7866 3.29505C23.6768 5.40483 22.4916 8.26631 22.4916 11.25C22.4916 11.8467 22.7286 12.419 23.1506 12.841C23.5725 13.2629 24.1448 13.5 24.7416 13.5C25.3383 13.5 25.9106 13.2629 26.3326 12.841C26.7545 12.419 26.9916 11.8467 26.9916 11.25C26.9961 9.55525 27.638 7.92422 28.7898 6.68095C29.9415 5.43767 31.5187 4.67314 33.2082 4.53923C34.8977 4.40532 36.5757 4.91184 37.9089 5.95815C39.2421 7.00446 40.1329 8.514 40.4044 10.1869L32.4309 16.1691L32.3522 16.2281L1.80001 39.15C1.04501 39.7162 0.487141 40.5055 0.205321 41.4062C-0.0764994 42.3069 -0.0680085 43.2734 0.229593 44.169C0.527194 45.0646 1.09884 45.844 1.86368 46.3969C2.62851 46.9498 3.54782 47.2482 4.49157 47.25H62.9916C63.936 47.25 64.8566 46.9528 65.6228 46.4006C66.389 45.8483 66.962 45.069 67.2607 44.173C67.5593 43.277 67.5685 42.3098 67.2869 41.4082C67.0053 40.5067 66.4472 39.7167 65.6916 39.15H65.6831ZM62.9916 42.75H4.49157L33.7416 20.8125L62.9916 42.75Z"
        fill={color}
      />
    </svg>
  );
}

HangarIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default HangarIcon;
